import { TableCell, TableRow, TableSortLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

export const columnData = [
  { id: 'id', numeric: true, label: 'id' },
  { id: 'competenceCategory', numeric: false, label: 'Kategoria kompetencji' },
  { id: 'competenceKind', numeric: false, label: 'Rodzaj kompetencji' },
  { id: 'competenceType', numeric: false, label: 'Typ kompetencji' },
  { id: 'skill', numeric: false, label: 'Umiejętność' },
  { id: 'isApproved', numeric: false, label: 'Status' },
  { id: '', numeric: false, label: 'Akcje' },
];

export class AdminCompetenceTempViewHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { order, orderBy } = this.props;

    return (
      <TableRow>
        {columnData.map(column => (
          <TableCell
            key={column.id}
            align={column.numeric ? 'right' : 'left'}
            sortDirection={orderBy === column.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === column.id}
              direction={order}
              onClick={this.createSortHandler(column.id)}
            >
              {column.label}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    );
  }
}

AdminCompetenceTempViewHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
};

export default AdminCompetenceTempViewHead;
